import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PREPAYMENTTOPUPBLOCK_LEGACY_FIELD_ORDER = [
  "shop_entity",
  "free_amount_button_position"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  prepaymentTopUpBlockDescriptor: _generatedPrepaymentTopUpBlockDescriptor,
  prepaymentTopUpBlockBlocDefinition,
  prepaymentTopUpBlockDashboardLayout,
  prepaymentTopUpBlockConfig,
  prepaymentTopUpBlockResolveConfig,
  prepaymentTopUpBlockProperties,
} = doodBlockConfig(
  {
    name: "Prepayment Top Up",
    componentType: 'PrepaymentTopUpBlockComponent',
    category: 'prepaid',
    description: "Prepayment Top Up.",
    keywords: [],
    allowedIn: [
      { bloc: '*Page', slot: '*' },
    ],
    sharedFields: {}
  },

  () => ({
    shop_entity: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        label: "pages.blocks.prepayment-top-up.shop-entity.label",
        max: 1,
      }
    }),
    free_amount_button_position: propertyValue({
      type: 'select',
      value: "first",
      options: {
        label: "pages.blocks.prepayment-top-up.free-amount-button-position.label",
        help: "pages.blocks.prepayment-top-up.free-amount-button-position.help",
        choices: [
          {
            value: "first",
            label: "pages.blocks.prepayment-top-up.free-amount-button-position.options.first",
          },
          {
            value: "last",
            label: "pages.blocks.prepayment-top-up.free-amount-button-position.options.last",
          },
          {
            value: "hidden",
            label: "pages.blocks.prepayment-top-up.free-amount-button-position.options.hidden",
          }
        ]
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.prepayment-top-up.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.prepayment-top-up.fieldset.shop.label",
            fields: ["shop_entity"],
          },
          {
            legend: "pages.blocks.prepayment-top-up.fieldset.free-amount-button.label",
            fields: ["free_amount_button_position"],
          },
        ],
      },
    ],
  })
);

export function prepaymentTopUpBlockDescriptor(): IBlockDescriptor;
export function prepaymentTopUpBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function prepaymentTopUpBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPrepaymentTopUpBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPrepaymentTopUpBlockDescriptor, prepaymentTopUpBlockProperties, fieldOrder);
}

export {
  prepaymentTopUpBlockBlocDefinition,
  prepaymentTopUpBlockDashboardLayout,
  prepaymentTopUpBlockProperties,
  prepaymentTopUpBlockConfig,
  prepaymentTopUpBlockResolveConfig,
};

export type PrepaymentTopUpBlockConfig = typeof prepaymentTopUpBlockConfig;
